import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Prospects/Tables";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import {
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import DeleteModal from "../../Components/Prospects/DeleteModal";
import { MdFileDownload } from "react-icons/md";
import * as XLSX from "xlsx";
import { FaSpinner } from "react-icons/fa6";

const Prospects = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("mobile");
  const [isDeleteOwner, setIsDeleteOwner] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(90, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const { t, i18n } = useTranslation();

  const initialValues = {
    name: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("filterType", filter);
    body.append("filterValue", filterValue);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    return await axios.post(`${Config.apiUrl}/getprospectsowners`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };


  const getProspectsSuccess = (res) => {
    if (res.data.status === "NOK" || res.data.data === false) {
      toast.error(res.data.msg || "An Error Occured");
    }
  };
  const getProspectsError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getProspectsMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getProspectsSuccess,
    onError: getProspectsError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getProspectsMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getProspectsMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
  };



//---------Owner Delete-------------------------------------------
  const deleteOwner= async ({ id }) => {
    const body = new FormData();
    body.append("id", id);
    return await axios.post(`${Config.apiUrl}/deleteowner`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onDeleteOwnerSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Deleted Successfully");
      setIsDeleteOwner(false);
      getProspectsMutate();
    }
  };

  const onDeleteOwnerError = (error) => {
    toast.error(
      error?.response?.data?.msg || "Unable to delete owner"
    );
  
    setIsDeleteOwner(false);
    setSelectedData("");
  };

  const { isLoading: isdeleteLoading, mutate: deleteMutate } =
    useMutation(deleteOwner, {
      onSuccess: onDeleteOwnerSuccess,
      onError: onDeleteOwnerError,
    });

    const statusMap = {
      1: "Unverified",
      2: "Verified",
      3: "Active",
      4: "Enrolled",
      5: "Defaulter",
    };

  
// -------- Download Prospects List to Excel --------
  const DownloadProspectsDetails = () => {
    const prospectsData = data?.data?.data;

    if (!Array.isArray(prospectsData) || prospectsData.length === 0) {
      toast.error("No prospect data available");
      return;
    }

    setDownloadLoading(true);
setTimeout(() => {
    try {
      const exportData = prospectsData.map((prospect) => ({
        Mobile: prospect.mobile || "",
        CreatedAt: prospect.createdAt || "",
        Status: statusMap[prospect.status] || prospect.status || "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Prospects");

      XLSX.writeFile(workbook, "ProspectsDetails.xlsx");

      toast.success("Prospects details downloaded");
    } catch (error) {
      console.error("Excel download error:", error);
      toast.error("File download failed");
    } finally {
      setDownloadLoading(false);
    }
    }, 200);
  };


  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{("Prospects")}</Title>
              <Underline />
            </div>
          </div>

          <div className="flex w-full justify-end items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              filter={filter}
              user={user}
              downloadProspectsDetails={DownloadProspectsDetails}
              downloadLoading={downloadLoading}
              t={t}
            />
          </div>

          {isDeleteOwner && (
            <DeleteModal
              deleteMutate={deleteMutate}
              isdeleteLoading={isdeleteLoading}
              setIsDeleteOwner={setIsDeleteOwner}
              selectedData={selectedData}
            />
          )}
          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                ApiData={error ? [] : data?.data?.data}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setIsDeleteOwner={setIsDeleteOwner}
                userType={user.userType}
              />
              {(error || data?.data?.msg == "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}

          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  filter,
  setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  downloadProspectsDetails,
  downloadLoading,
  t,
}) => {
  const today = moment().format("YYYY-MM-DD");
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-4 items-end">
            {filter !== "status" && filter !== "paystatus" ? (
              <InputGroup className="w-[200px]">
                <Label htmlFor="filterVal">{("")}</Label>
                <Field
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  inputMode={filter === "mobile" ? "numeric" : "text"}
                  maxLength={filter === "mobile" ? "10" : undefined}
                  pattern={filter === "mobile" ? "[0-9]*" : undefined}
                  // className="ml-1"
                  value={filterValue}
                  onChange={(e) => {
                    if (filter === "mobile") {
                      const value = e.target.value;
                      // Restrict input to digits only, up to 10 characters
                      if (/^\d{0,10}$/.test(value)) {
                        ChangeHandler(e);
                      }
                    } else {
                      ChangeHandler(e);
                    }
                  }}
                  className=" ml-1 border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color py-2"
                />
              </InputGroup>
            ) : filter === "status" ? (
              <InputGroup
                className="w-[120px]"
                style={{ flexBasis: "content" }}
              >
                <Label htmlFor="filter">{t("Select")}</Label>
                <Select
                  autoComplete="off"
                  className="h-10 w-full px-2"
                  style={{ height: "40px" }}
                  value={filterValue}
                  onChange={ChangeHandler}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    {t("Select Status")}
                  </MenuItem>
                  <MenuItem value="1">{t("Unverfied")}</MenuItem>
                  <MenuItem value="2">{t("Verified")}</MenuItem>
                </Select>
              </InputGroup>
            ) : null}

            <InputGroup
              // className="min-w-[120px]"
              style={{ flexBasis: "content" }}
            >
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  setFilterValue("");
                }}
              >
                <MenuItem value="mobile">Phone</MenuItem>
                <MenuItem value="status">Status</MenuItem>
              </Select>
            </InputGroup>
            <button
              type="button"
              disabled={downloadLoading}
              onClick={downloadProspectsDetails}
              className="h-10 w-10 flex items-center justify-center gap-2 border border-gray-300 rounded-md bg-white text-gray-600 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {downloadLoading ? (
                <FaSpinner className="animate-spin" size={18} />
              ) : (
                <MdFileDownload size={18} />
              )}
            </button>
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md overflow-auto`;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-end gap-4 mt-8`;
export default Prospects;
